var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 33C1 15.3269 15.3269 1 33 1V1C50.6731 1 65 15.3269 65 33V33C65 50.6731 50.6731 65 33 65V65C15.3269 65 1 50.6731 1 33V33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M16.2397 68.9364C46.0492 68.9364 70.2147 67.6018 70.2147 65.9554C70.2147 64.3091 46.0492 62.9744 16.2397 62.9744C-13.5699 62.9744 -37.7354 64.3091 -37.7354 65.9554C-37.7354 67.6018 -13.5699 68.9364 16.2397 68.9364Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8658 14.5376C26.8573 14.5376 29.2823 12.1307 29.2823 9.16171C29.2823 6.19271 26.8573 3.78586 23.8658 3.78586C20.8743 3.78586 18.4492 6.19271 18.4492 9.16171C18.4492 12.1307 20.8743 14.5376 23.8658 14.5376Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M23.8661 19.408C29.5685 19.408 34.1912 14.82 34.1912 9.16048C34.1912 3.50093 29.5685 -1.08704 23.8661 -1.08704C18.1637 -1.08704 13.541 3.50093 13.541 9.16048C13.541 14.82 18.1637 19.408 23.8661 19.408Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6853 40.6824H24.9258V65.5576H56.6853V40.6824Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M56.6853 40.6824H24.9258V65.5576H56.6853V40.6824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7755 40.6824H8.37891V65.5576H31.7755V40.6824Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6537 52.1493H20.0781V65.5574H27.6537V52.1493Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7706 47.8351H36.6543V56.4629H52.7706V47.8351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M52.7706 47.8351H36.6543V56.4629H52.7706V47.8351Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2493 52.4458H12.7568V60.2543H16.2493V52.4458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2268 19H34.4229V28.9671H40.2268V19Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7171 59.8908C26.159 59.8908 26.5172 59.5353 26.5172 59.0968C26.5172 58.6582 26.159 58.3027 25.7171 58.3027C25.2752 58.3027 24.917 58.6582 24.917 59.0968C24.917 59.5353 25.2752 59.8908 25.7171 59.8908Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 40L19.9993 26L32.2 40H9.2Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6348 26H20L32.4111 40.4732H33.6525H57.0459L44.6348 26Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M44.6043 26H20L32.3957 40H33.6356H57L44.6043 26Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5369 39.7616H7.18457V42.6165H57.5369V39.7616Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M57.5369 39.7616H7.18457V42.6165H57.5369V39.7616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M57.5364 39.7616H31.7744V42.6165H57.5364V39.7616Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1206 26.3721C59.1206 25.8071 58.8945 25.2653 58.492 24.8658C58.0895 24.4663 57.5436 24.2419 56.9743 24.2419C56.8584 24.2418 56.7426 24.2513 56.6283 24.2702C56.3818 23.8141 56.0156 23.4326 55.5684 23.1663C55.1212 22.9 54.6098 22.7588 54.0883 22.7577H53.9835C54.1094 22.2552 54.1184 21.7308 54.0097 21.2244C53.901 20.718 53.6776 20.2427 53.3563 19.8348C53.0349 19.4268 52.6242 19.0969 52.1553 18.87C51.6863 18.643 51.1714 18.5251 50.6497 18.5251C50.128 18.5251 49.6131 18.643 49.1442 18.87C48.6752 19.0969 48.2645 19.4268 47.9432 19.8348C47.6219 20.2427 47.3984 20.718 47.2897 21.2244C47.1811 21.7308 47.19 22.2552 47.316 22.7577H47.2112C46.8231 22.7449 46.4363 22.8098 46.074 22.9484C45.7117 23.087 45.3811 23.2965 45.102 23.5645C44.8229 23.8325 44.601 24.1534 44.4494 24.5082C44.2978 24.8631 44.2197 25.2446 44.2197 25.63C44.2197 26.0154 44.2978 26.3968 44.4494 26.7517C44.601 27.1065 44.8229 27.4275 45.102 27.6954C45.3811 27.9634 45.7117 28.1729 46.074 28.3115C46.4363 28.4501 46.8231 28.515 47.2112 28.5022H57.2537V28.4833C57.7697 28.4154 58.2434 28.164 58.5867 27.7757C58.93 27.3874 59.1198 26.8887 59.1206 26.3721V26.3721Z",
    fill: "#CCE9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6 55.6917H35.8994V57.2673H53.6V55.6917Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M53.6 55.6917H35.8994V57.2673H53.6V55.6917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M53.6 55.6917H35.8994V57.2673H53.6V55.6917Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 64C15.8792 64 2 50.1208 2 33H0C0 51.2254 14.7746 66 33 66V64ZM64 33C64 50.1208 50.1208 64 33 64V66C51.2254 66 66 51.2254 66 33H64ZM33 2C50.1208 2 64 15.8792 64 33H66C66 14.7746 51.2254 0 33 0V2ZM33 0C14.7746 0 0 14.7746 0 33H2C2 15.8792 15.8792 2 33 2V0Z",
    fill: "#E6EBEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_444"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 33C1 15.3269 15.3269 1 33 1V1C50.6731 1 65 15.3269 65 33V33C65 50.6731 50.6731 65 33 65V65C15.3269 65 1 50.6731 1 33V33Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOwner);
export default __webpack_public_path__ + "static/media/HomeOwner.9675a6385d23b08929161c05ee41db9c.svg";
export { ForwardRef as ReactComponent };